import { FourArticlesHighlightBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpFourArticlesHighlightBlock } from './AmpFourArticlesHighlightBlock';
import { FourArticlesHighlightBlock } from './FourArticlesHighlightBlock';

export const FourArticlesHighlightBlockMapping: BlockMapping<FourArticlesHighlightBlockData> =
  {
    invariant: [],
    width: 'GRID',
    Component: FourArticlesHighlightBlock,
    AmpComponent: AmpFourArticlesHighlightBlock,
  };
